'use strict';

import React, { Component } from 'react'

import { CSSTransition } from 'react-transition-group'

import Layout from '@Layout/BackOffice'

import _ from 'lodash'

import { form as config } from '@Config/EC/EC'

import CreationForm from '@/Form/CreationForm'

const { app, moment } = window;

function getInitialState (component)
{
	if (app.state.session?.permissions?.title !== 'Membre de synergies')
	{
		return { init: false };
	}

	const id = document.location.pathname
	.slice(document.location.pathname.lastIndexOf('/')+1);

	if (!id) return { init: false, error: 'Page invalide.' };

	const state =
	{
		form_data:
		{
			start: moment().startOf('month').format('YYYY-MM-DD'),
			end: moment().endOf('month').format('YYYY-MM-DD')
		},

		init: true,
		deleted: false,

		EC_id: id,

		status_messages: { }
	};

	const form_config = _.cloneDeep(config);

	form_config.can_delete = true;

	form_config.fields = _.assign(
	{
		code:
		{
			label: 'Code',
			readOnly: true
		}
	},
	form_config.fields);

	form_config.fields['budget_range'] =
	{
		label: 'Base tarifaire CSE de + 50 salariés (ETP)',
		type: 'select',
		options:
		[
			{
				value: 'none',
				label: 'Désactivé'
			},
			{
				value: '1',
				label: 'De 2276 à 3000 €'
			},
			{
				value: '2',
				label: 'De 3001 à 4000 €'
			},
			{
				value: '3',
				label: 'De 4001 à 5000 €'
			},
			{
				value: '4',
				label: 'De 5001 à 6999 €'
			},
			{
				value: '5',
				label: 'De 7000 à 9147 €'
			},
			{
				value: '6',
				label: 'De 9148 à 12.500 €'
			},
			{
				value: '7',
				label: 'De 12.501 à 15.244 €'
			},
			{
				value: '8',
				label: 'De 15.245 à 25.000 €'
			},
			{
				value: '9',
				label: 'De 25.001 à 50.000 €'
			},
			{
				value: '10',
				label: '50.001 et +'
			}
		]
	};

	form_config.fields['exchange_documents'] =
	{
		label: 'PDF/Image',
		type: 'image',
		multiple: true
	};

	form_config.collapses.unshift(
	{
		type: 'collapse',
		title: 'Communication avec le CE',
		elements:
		[
			'budget_range',
			'exchange_documents'
		]
	});

	state.form_config = form_config;

	return state;
}

export default class NewECPage extends Component
{
	state = getInitialState(this);

	UNSAFE_componentWillMount ()
	{
		var component = this;

		app.resetFunctions();
	}

	render ()
	{
		const props = this.props;

		let form_config = _.cloneDeep(config);

		form_config.fields = _.assign(
		{
			'_contacts[email]':
			{
				type: 'email'
			},

			'_contacts[firstname]':
			{
				type: 'text'
			},

			'_contacts[lastname]':
			{
				type: 'text'
			}
		},
		config.fields);

		if (config.repeatable instanceof Array === false) form_config.repeatable = [];

		form_config.repeatable.push('_contacts');

		form_config.collapses.push(
		{
			title: 'Contacts',
			elements:
			[
				{
					type: 'table',
					table_name: '_contacts',
					columns:
					{
						'E-mail (login)': '_contacts[email]',
						'Prénom'        : '_contacts[firstname]',
						'Nom'           : '_contacts[lastname]'
					},
					add: true,
					add_label: 'Ajouter'
				}
			]
		});

		var output =
		(
			<Layout page_title="Nouveau Comité d'Entreprise" history={ props.history }>

				<div className="page-content">

					<div className="page-form-container">

						<CSSTransition
							classNames="a-form-transition"
							appear={ true }
							enter={ true }
							exit={ true }
							timeout={{ appear:500, enter: 240, exit: 320 }}>

							<CreationForm config={ form_config } />

						</CSSTransition>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
